import React, { useEffect } from 'react';
import { baseUrl, baseUrlRisk, recommendationUrl } from '../constants/constants';
import { getApiResponseData, getRiskAPIResponseData, getPostResponseAPIData } from '../services/apiservices';
import { useDispatch, useSelector } from 'react-redux';
import { pushTableData, pushRiskTableData } from '../slices/recommendationTableSlice';
import { pushOverallRiskData } from '../slices/doughnutChartSlice';
import { pushOverallTrendData } from '../slices/trendLinesSlice';
import { pushOverallHeatMap } from '../slices/HeatMapSlice';
import { pushSelectedApplication } from '../slices/HeatMapSlice';
import { pushExportRecommandationApi, pushExportRiskApi } from '../slices/ApiStateSlice';
import DashBoard from './Dashboard/Dashboard';
import { PageLayout } from './MainPageStyle';
import { pushShowSpinner, pushHideSpinner } from '../slices/SpinnerSlice';
import { setSearchString } from '../slices/RiskFilterSlice';

const MainPage = ({
  history
}) => {
  const [updatedpage, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [watch, setWatch] = React.useState(0);
  const [riskTablePage, setRiskTablePage] = React.useState(0);
  const [riskTableRowsPerPage, setRiskTableRowsRowsPerPage] = React.useState(10);
  const [recomandationLoading, setRecomenationLoading] = React.useState(false);
  const [riskLoading, setRiskLoading] = React.useState(false);
  const [overallTrendLoading, setOverallTrendLoading] = React.useState(false);
  const [order, setOrder] = React.useState('DSC');
  const [orderBy, setOrderBy] = React.useState('originRiskScore');
  const [riskColumOrder, setRiskColumOrder] = React.useState('DSC');
  const [riskColumOderBy, setRiskColumOderBy] = React.useState('originRiskScore');

  const handlesetLoading = recomendationSpinnerStatus => {
    setRecomenationLoading(recomendationSpinnerStatus);
  };

  const handleriskLoading = riskSpinnerLoading => {
    setRiskLoading(riskSpinnerLoading);
  };

  const handleOverallTrendLoading = overalTrendSpinnerLoading => {
    setOverallTrendLoading(overalTrendSpinnerLoading);
  };

  const handleRequestSort = property => {
    const isDsc = orderBy === property && order === 'DSC';
    setOrder(isDsc ? 'ASC' : 'DSC');
    setOrderBy(property);
  };

  const handleSetriskTableSortString = property => {
    const isDsc = riskColumOderBy === property && riskColumOrder === 'DSC';
    setRiskColumOrder(isDsc ? 'ASC' : 'DSC');
    setRiskColumOderBy(property);
  };

  const updatedWatchData = useSelector(state => state.recommendationTable.WatchResponseData);
  const nextTableData = useSelector(state => state.recommendationTable.dashboardResponse);
  const risknextTableData = useSelector(state => state.recommendationTable.riskTableResponse);
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const recoReqBody = useSelector(state => state.riskFilterSlice.recoReqBody);
  useEffect(() => {
    dispatch(pushShowSpinner(true));
    let paginationQueryString = '';

    if (watch) {
      if (!applyEvent) {
        paginationQueryString = `?limit=${rowsPerPage}&offset=${updatedpage}&sortBy=${orderBy}:${order}&filter=underWatch=${watch},recoType=Any&view=recommendation`;
        let exportUrl = baseUrl + paginationQueryString;
        dispatch(pushExportRecommandationApi(exportUrl));
        let url = baseUrl + paginationQueryString;
        dispatch(getApiResponseData(url, 'dashboardResponse'));
      } else {
        dispatch(getPostResponseAPIData(recommendationUrl, 'recoOriginFilter', recoReqBody));
      }
    } else {
      if (!applyEvent) {
        paginationQueryString = `?limit=${rowsPerPage}&offset=${updatedpage}&sortBy=${orderBy}:${order}&view=recommendation&filter=recoType=Any`;
        let exportUrl = baseUrl + paginationQueryString;
        dispatch(pushExportRecommandationApi(exportUrl));
        let url = baseUrl + paginationQueryString;
        dispatch(getApiResponseData(url, 'dashboardResponse'));
      } else {
        dispatch(getPostResponseAPIData(recommendationUrl, 'recoOriginFilter', recoReqBody));
      }
    }
  }, [rowsPerPage, updatedpage, watch, updatedWatchData, order, orderBy]);
  useEffect(() => {
    dispatch(pushShowSpinner(true));
    let paginationStringOrigin = `origins-wise?limit=${riskTableRowsPerPage}&offset=${riskTablePage}&sortBy=${riskColumOderBy}:${riskColumOrder}`;
    let riskUrl = baseUrlRisk + paginationStringOrigin;
    dispatch(pushExportRiskApi(riskUrl));
    dispatch(getRiskAPIResponseData(riskUrl, 'riskTableResponse'));
  }, [riskTableRowsPerPage, riskTablePage, riskColumOrder, riskColumOderBy]);
  const apiResponseData = useSelector(state => state.recommendationTable.dashboardResponse);
  const riskTableDataPagination = useSelector(state => state.recommendationTable.riskTableResponse);
  const riskApiResponseData = useSelector(state => state.recommendationTable.riskResponse);
  const overallTrendApiResponseData = useSelector(state => state.recommendationTable.trendResponse);
  const dataDoughnut = useSelector(state => state.doughnutChart.dataDoughnut);
  const dataLine = useSelector(state => state.trendLines.dataLine);
  const heatMap = useSelector(state => state.heatMapSlice.dataSet);
  const riskTableData = useSelector(state => state.recommendationTable.riskTableData);
  const tableData = useSelector(state => state.recommendationTable.tableData);
  const dispatch = useDispatch();
  useEffect(() => {
    let paginationStringOrigin = 'origins-wise';
    let paginationStringOverall = 'overall-trend?limit=1000&offset=0';
    let riskUrl = baseUrlRisk + paginationStringOrigin;
    let trendUrl = baseUrlRisk + paginationStringOverall;
    dispatch(getRiskAPIResponseData(riskUrl, 'riskResponse'));
    dispatch(getRiskAPIResponseData(trendUrl, 'trendResponse'));
  }, []);
  useEffect(() => {
    if (apiResponseData && apiResponseData.data) {
      let displayData = apiResponseData.data.responseList;
      dispatch(pushTableData(displayData));
      dispatch(pushHideSpinner(false));
    }

    if (riskApiResponseData && riskApiResponseData.data) {
      let overallRiskData = riskApiResponseData.data.responseList;
      dispatch(pushRiskTableData(overallRiskData));
      dispatch(pushOverallRiskData(overallRiskData));
      dispatch(pushOverallHeatMap(overallRiskData));
      dispatch(pushHideSpinner(false));
    }

    if (overallTrendApiResponseData && overallTrendApiResponseData.data) {
      let overallTrendData = overallTrendApiResponseData.data;
      dispatch(pushOverallTrendData(overallTrendData));
      setOverallTrendLoading(true);
    }

    if (riskTableDataPagination && riskTableDataPagination.data) {
      let riskTableData = riskTableDataPagination.data.responseList;
      dispatch(pushRiskTableData(riskTableData));
      dispatch(pushHideSpinner(false));
    }
  }, [apiResponseData, riskApiResponseData, overallTrendApiResponseData, riskTableDataPagination]);

  const clickHandler = (event, chartContext, config) => {
    let selectedLabel = config.globals.categoryLabels[event.target.attributes['j'].value];
    handleTableRowClick(selectedLabel[1]);
  };

  const handleTableRowClick = selectedLabel => {
    let appId = '';
    dispatch(pushSelectedApplication(selectedLabel));

    if (riskApiResponseData && riskApiResponseData.data) {
      let riskScoreObj = riskApiResponseData.data.responseList.filter(item => {
        return item.origin === selectedLabel;
      });
      appId = riskScoreObj[0].appId;
    }

    history.push(`/analytics/applications/${appId}`);
    dispatch(setSearchString(''));
  };

  return /*#__PURE__*/React.createElement(PageLayout, null, /*#__PURE__*/React.createElement(DashBoard, {
    history: history,
    dataDoughnut: dataDoughnut,
    dataLine: dataLine,
    heatMap: heatMap,
    clickHandler: clickHandler,
    riskTableData: riskTableData,
    tableData: tableData,
    setRowsPerPage: setRowsPerPage,
    setPage: setPage,
    nextTableData: nextTableData,
    rowsPerPage: rowsPerPage,
    handleRequestSort: handleRequestSort,
    watch: watch,
    setWatch: setWatch,
    setRiskTablePage: setRiskTablePage,
    setRiskTableRowsRowsPerPage: setRiskTableRowsRowsPerPage,
    handleSetriskTableSortString: handleSetriskTableSortString,
    riskTableRowsPerPage: riskTableRowsPerPage,
    recomandationLoading: recomandationLoading,
    handlesetLoading: handlesetLoading,
    riskLoading: riskLoading,
    handleriskLoading: handleriskLoading,
    overallTrendLoading: overallTrendLoading,
    handleOverallTrendLoading: handleOverallTrendLoading,
    risknextTableData: risknextTableData,
    order: order,
    orderBy: orderBy,
    riskColumOrder: riskColumOrder,
    riskColumOderBy: riskColumOderBy,
    handleTableRowClick: handleTableRowClick,
    pageType: "application"
  }));
};

export default MainPage;